import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';

export function registerScrollTo (): void {
	Vue.use(VueScrollTo);
}
